import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {TrackingErrorsFactory} from '../Errors/factory.js'
import BrazeUserRepository from './BrazeUserRepository.js'
import EmptyTrackingRepository from './EmptyTrackingRepository.js'
import {HttpTrackingRepository} from './HttpTrackingRepository.js'
import {SessionStorageCsatNpsRepository} from './SessionStorageCsatNpsRepository.js'
import SessionStorageRepository from './SessionStorageRepository.js'

export default class TrackingRepositoriesFactory {
  static emptyTrackingRepository = () => new EmptyTrackingRepository()

  static sessionStorageRepository = ({config}) => new SessionStorageRepository({config})

  static sessionStorageCsatNpsRepository = ({config}) => SessionStorageCsatNpsRepository.create({config})

  static brazeUserRepository = ({config}) => new BrazeUserRepository({config})

  static httpTrackingRepository = ({config}) =>
    new HttpTrackingRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      savePageViewHitTrackingErrorFactory: TrackingErrorsFactory.savePageViewHitTrackingError
    })
}
